"use strict";

exports.onRouteUpdate = function () {
  if (document.querySelector('.instagram-media') !== null) {
    // Wait to ensure page is rendered first.
    setTimeout(function () {
      if (typeof gatsbyLoadInstagram !== "undefined" && typeof window.gatsbyLoadInstagram === "function") {
        window.gatsbyLoadInstagram();
      }
    }, 0);
  }
};